// Import the RTK Query methods from the React-specific entry point
import { Paths } from './paths/paths';
import { ProductDetails as ProductDetailsRequest } from './request/ProductDetails';
import { cameliseDeep } from '@utils/functions/camelise';
import { apiSlice } from './apiSlice';
import { Product, ProductNotificationRequestSuccess } from './response/Product';
import { ProductDetails } from './response/ProductDetails';
import { TabDetails } from './response/TabDetails';
import { Tab as TabRequest } from './request/Tab';

export const productSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    products: builder.query<Product[], void>({
      query: () => Paths.GetProducts,
      transformResponse: (data: unknown) => cameliseDeep<Product[]>(data),
    }),
    productDetails: builder.query<ProductDetails, ProductDetailsRequest>({
      query: (arg) => {
        const { productId } = arg;
        return {
          url: Paths.GetProductDetails,
          params: { productId },
        };
      },
      transformResponse: (data: unknown) => {
        const camelized = cameliseDeep<ProductDetails>(data);
        camelized.tabs.forEach((x) => {
          x.id = `${x.id}`;
        });

        return camelized;
      },
    }),
    tab: builder.query<TabDetails, TabRequest>({
      query: (arg) => {
        const { tabId } = arg;
        return {
          url: Paths.GetTab,
          params: { tabId },
        };
      },
      transformResponse: (data: unknown) => cameliseDeep<TabDetails>(data),
    }),
    productNotificationRequest: builder.query<
      ProductNotificationRequestSuccess,
      ProductDetailsRequest
    >({
      query: (data) => ({
        url: Paths.ProductNotificationRequest,
        method: 'GET',
        params: data,
      }),
      transformResponse: (data: unknown) =>
        cameliseDeep<ProductNotificationRequestSuccess>(data),
    }),
    createProductNotificationRequest: builder.mutation<
      ProductNotificationRequestSuccess,
      ProductDetailsRequest
    >({
      query: (data) => ({
        url: Paths.ProductNotificationRequest,
        method: 'POST',
        body: data,
      }),
      transformResponse: (data: unknown) =>
        cameliseDeep<ProductDetailsRequest>(data),
    }),
  }),
});

export const {
  useProductsQuery,
  useProductDetailsQuery,
  useTabQuery,
  useProductNotificationRequestQuery,
  useCreateProductNotificationRequestMutation,
} = productSlice;
